<div
  class="w-full max-w-md rounded border border-gray-100 bg-white p-6 shadow-sm"
>
  <div class="flex flex-col items-center text-center">
    <div class="mb-4" aria-hidden="true">
      @if (type() === 'danger') {
      <i class="bi bi-exclamation-triangle-fill text-7xl text-red-500"></i>
      } @else if (type() === 'warning') {
      <i class="bi bi-exclamation-triangle-fill text-7xl text-amber-500"></i>
      } @else if (type() === 'success') {
      <i class="bi bi-check-circle-fill text-7xl text-emerald-500"></i>
      } @else {
      <i
        class="bi bi-info-circle-fill text-7xl text-[var(--color-primary)]"
      ></i>
      }
    </div>

    <h3 class="mb-2 text-lg font-semibold text-stone-900">{{ title() }}</h3>
    <p
      class="text-sm text-stone-600"
      [class.mb-2]="!!messageEmphasis()"
      [class.mb-4]="!messageEmphasis()"
    >
      {{ message() }}
    </p>
    @if (messageEmphasis()) {
    <p class="mb-4 text-sm italic text-stone-800">{{ messageEmphasis() }}</p>
    }
  </div>

  <div class="flex flex-col">
    @if (promptEnabled()) {
    <label
      class="mb-1 block text-left text-sm font-medium text-gray-700"
      for="confirm-dialog-prompt"
    >
      {{ promptLabel() }}
    </label>
    <input
      id="confirm-dialog-prompt"
      type="text"
      class="mb-1 block w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-500 transition focus:border-[var(--color-primary)] focus:outline-none focus:ring-1 focus:ring-[var(--color-primary)]"
      [class.border-red-500]="!!promptError()"
      [attr.maxlength]="promptMaxLength()"
      [placeholder]="promptPlaceholder()"
      [value]="promptValue()"
      (input)="onPromptInput($event)"
      (keydown.enter)="onConfirm()"
    />
    @if (promptError()) {
    <p class="mb-3 text-left text-sm text-red-600">{{ promptError() }}</p>
    } @else {
    <div class="mb-3"></div>
    } }
    <div
      class="mt-auto flex gap-3"
      [class.justify-center]="!cancelText()"
      [class.justify-end]="!!cancelText()"
    >
      @if (cancelText()) {
      <button
        type="button"
        class="rounded border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)]"
        (click)="onCancel()"
      >
        {{ cancelText() }}
      </button>
      }
      <button
        type="button"
        class="rounded px-4 py-2 text-sm font-medium text-white transition focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)]"
        [ngClass]="{
            'bg-red-600 hover:bg-red-700': type() === 'danger',
            'bg-amber-500 hover:bg-amber-600': type() === 'warning',
            'bg-emerald-600 hover:bg-emerald-700': type() === 'success',
            'bg-[var(--color-primary)] hover:bg-[var(--color-primary-hover)]': type() === 'info'
          }"
        (click)="onConfirm()"
      >
        {{ confirmText() }}
      </button>
    </div>
  </div>
</div>
